export default "__VITE_ASSET__Cf3rgJA8__"